import gql from 'graphql-tag';
import HtmlItemFragment from './HtmlItem.gql';
import ImageItemFragment from './ImageItem';
import SideBySideItemFragment from './SideBySideItem';
import VideoItemFragment from './VideoItem.gql';

export default gql`
  fragment FaqItemFragment on FaqItem {
    id
    type
    data {
      title
      items {
        ...HtmlItemFragment
        ...ImageItemFragment
        ...SideBySideItemFragment
        ...VideoItemFragment
      }
      isPartner
    }
  }
  ${HtmlItemFragment}
  ${ImageItemFragment}
  ${SideBySideItemFragment}
  ${VideoItemFragment}
`;
